/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取文件的部分元信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetSimplifiedObjectMetaParams {
  constructor(public filePath: string) {}
}

export default async function (
  params: GetSimplifiedObjectMetaParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oss.SimplifiedFileMetaDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oss/simplifiedFileMeta`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
